import React, { Component } from 'react';
import './tracsoftsettings.css';
import { version } from 'react-dom';
import { showNotification } from '../../StatusNotification';

export class TracSoftSettings extends Component {
    static displayName = TracSoftSettings.name;

    constructor(props) {
        super(props);
        this.state = {
            tracSoftSettingsModel: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newTracSoftSettingsModel = this.state.tracSoftSettingsModel;
        newTracSoftSettingsModel[e.target.name] = e.target.value;
        this.setState({ tracSoftSettingsModel: newTracSoftSettingsModel });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let tracSoftSettingsModel = this.state.tracSoftSettingsModel;

        fetch('AdminSettings/UpdateTracSoftSettings', {
            method: 'POST',
            body: JSON.stringify(tracSoftSettingsModel),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (data === "Saved") {
                    showNotification(data, "success");
                } else {
                    showNotification(data, "error");
                }
            }
        )
    }

    render() {
        let dynamicFormEmail;
        let versionUpdateEmail;
        let versionLimit;

        if (this.state.tracSoftSettingsModel != null) {
            let tsSettingsModel = this.state.tracSoftSettingsModel
            dynamicFormEmail = tsSettingsModel.dynamicFormEmail;
            versionUpdateEmail = tsSettingsModel.versionUpdateEmail;
            versionLimit = tsSettingsModel.versionLimit;
        }

        return (
            <div className='tracsoft-admin-settings'>
                <form onSubmit={this.handleSubmit} className='grid-wrapper'>
                    <div className='dual-grid--offset'>
                        <div className='dual-grid__1-2 form-title'>
                            <h2>TracSoft Settings</h2>
                        </div>

                        <label>Dynamic Form Email: </label>
                        <input name='dynamicFormEmail' type='email' defaultValue={dynamicFormEmail} onChange={this.handleChange} required />

                        <label>Version Update Email: </label>
                        <input name='versionUpdateEmail' type='email' defaultValue={versionUpdateEmail} onChange={this.handleChange} required />

                        <label>Version Limit: </label>
                        <input name='versionLimit' type='number' defaultValue={versionLimit} onChange={this.handleChange} required step='1' min='3' />

                        <div className='dual-grid__1-2'>
                            <button type='submit' className='form-button'>Save</button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('AdminSettings/GetTracSoftSettings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            tracSoftSettingsModel: data
        });
    }
}

export default TracSoftSettings;
